<script setup lang="ts">
import Modal from '~/components/common/ModalV2.vue'
import PDFViewer from '~/components/common/PDFViewer.vue'
import { useModalStore } from '~/stores/modal'

const props = defineProps<{ url: string }>()
const emit = defineEmits(['close'])

const modalStore = useModalStore()
const { close: closeModal } = modalStore

const isOpen = computed(
  () => modalStore.modals.pdfViewerModalOpen && Boolean(props.url),
)

const close = () => {
  closeModal('pdfViewerModal')
  emit('close')
}
</script>

<template>
  <Modal
    :is-open="isOpen"
    name="pdfViewerModal"
    modal-classes="max-w-full max-h-full p-0 aspect-video"
    modal-overlay-classes="!p-2"
    @close="close"
  >
    <PDFViewer :url="url" />
  </Modal>
</template>
